<template>
  <q-page class="container" padding>
    <div class="row col-12 justify-between align-center">
      <p class="text-h6 text-brand-1 text-weight-bolder">
        Gerenciamento de Chaves Facial
      </p>
    </div>
    <div
      class="row no-wrap col-12 q-gutter-sm text-brand-5 text-weight-bold q-mt-md items-center"
    >
      <div style="width: 16.6%">
        <div class="input-label">Digite o uuid</div>
        <div>
          <q-input
            class="input-modal input-new-design"
            v-model="filtros.uuid"
            dense
            autocomplete="off"
            outlined
            maxlength="100"
          />
        </div>
      </div>
      <div style="width: 16.6%">
        <div class="input-label">Digite o tenant</div>
        <div>
          <q-input
            class="input-modal input-new-design"
            v-model="filtros.tenant"
            dense
            autocomplete="off"
            outlined
            maxlength="100"
          />
        </div>
      </div>

      <div style="width: 16.6%">
        <div class="input-label">Digite a key</div>
        <div>
          <q-input
            class="input-modal input-new-design"
            v-model="filtros.key"
            dense
            autocomplete="off"
            outlined
            maxlength="100"
          />
        </div>
      </div>

      <div style="width: 16.6%">
        <div class="input-label">Digite o secret</div>
        <div>
          <q-input
            class="input-modal input-new-design"
            v-model="filtros.secret"
            dense
            autocomplete="off"
            outlined
            maxlength="100"
          />
        </div>
      </div>
      <div style="width: 16.6%">
        <div class="input-label">Status</div>
        <q-select
          v-model="filtros.status"
          :options="statusOptions"
          dense
          outlined
          map-options
          emit-value
          option-value="value"
          class="input"
        />
      </div>
      <div style="width: 16.6%">
        <div class="input-label">Data Inicial</div>

        <q-input
          class="input-new-design"
          dense
          outlined
          mask="##/##/####"
          v-model="filtros.dataInicial"
          :rules="[(val) => validarDataEmissao(val) || 'Data Invalida']"
        >
          <template v-slot:append>
            <q-icon name="event" class="cursor-pointer">
              <q-popup-proxy
                cover
                transition-show="scale"
                transition-hide="scale"
              >
                <q-date
                  :locale="myLocale"
                  mask="DD/MM/YYYY"
                  v-model="filtros.dataInicial"
                >
                  <div class="row items-center justify-end">
                    <q-btn v-close-popup label="Fechar" color="primary" flat />
                  </div>
                </q-date>
              </q-popup-proxy>
            </q-icon>
          </template>
        </q-input>
      </div>
    </div>
    <div>
      <div
        class="row col-12 q-gutter-sm text-brand-5 text-weight-bold q-mt-sm items-center"
      >
        <!--<div class="col-md-2 col-sm-12 col-xs-12">
            <div>Unidade</div>
            <ListaUnidadesSelect class="input-new-design" />
          </div>-->

        <div class="col-md-2 q-ml-sm">
          <div class="input-label">Data Final</div>

          <q-input
            class="input-new-design"
            dense
            outlined
            mask="##/##/####"
            v-model="filtros.dataFinal"
            :rules="[(val) => validarDataEmissao(val) || 'Data Invalida']"
          >
            <template v-slot:append>
              <q-icon name="event" class="cursor-pointer">
                <q-popup-proxy
                  cover
                  transition-show="scale"
                  transition-hide="scale"
                >
                  <q-date
                    :locale="myLocale"
                    mask="DD/MM/YYYY"
                    v-model="filtros.dataFinal"
                  >
                    <div class="row items-center justify-end">
                      <q-btn
                        v-close-popup
                        label="Fechar"
                        color="primary"
                        flat
                      />
                    </div>
                  </q-date>
                </q-popup-proxy>
              </q-icon>
            </template>
          </q-input>
        </div>

        <div class="col-md-2 q-mt-xs">
          <div class="input-label">Excluido</div>
          <q-select
            v-model="filtros.excluido"
            :options="excluidoOptions"
            dense
            outlined
            map-options
            emit-value
            option-value="value"
            class="input"
          />
        </div>

        <div class="col-md-2 q-mt-xs">
          <div class="input-label">Linhas por Pagina</div>
          <q-select :options="perpageOptions" dense outlined class="input" />
        </div>
        <div>
          <p></p>
          <q-btn
            class="q-mt-xs"
            label="Criar Chave"
            no-caps
            icon="add"
            style="background-color: #21324a; border-radius: 8px; color: white"
            @click="rightDrawerOpen = true"
          />
        </div>
      </div>
    </div>

    <Transition name="slide-fade">
      <q-card v-if="rightDrawerOpen" class="drawer-modal">
        <div class="row q-pa-md text-weight-bold">
          <div class="row col-12 items-center">
            <q-icon
              style="cursor: pointer"
              name="close"
              class="q-mr-md"
              size="22px"
              @click="rightDrawerOpen = false"
            />
            <span class="texto-titulo-modal">
              {{
                editarChave
                  ? `Editar Chave: ${nomeTerceiroEditar}`
                  : "Criar nova Chave"
              }}
            </span>
          </div>
        </div>
        <div v-if="!editarChave" style="width: 100%; height: 89%">
          <div class="column col-12 justify-between no-wrap container-modal">
            <div class="q-px-md text-weight-bold">
              <div>
                <div class="texto-titulo-input">Cliente</div>
                <q-select
                  dense
                  outlined
                  class="input-new-design"
                  v-model="criarChave.tenant"
                  :options="listaClientes"
                  map-options
                  emit-value
                  option-value="clienteId"
                  option-label="clienteId"
                >
                </q-select>
              </div>
              <div>
                <div class="texto-titulo-input">Key</div>
                <q-input
                  class="input-modal input-new-design"
                  v-model="criarChave.key"
                  dense
                  autocomplete="off"
                  outlined
                  maxlength="100"
                />
              </div>

              <div class="q-mt-xs">
                <div class="texto-titulo-input">Secret</div>
                <q-input
                  autocomplete="off"
                  class="input-modal input-new-design"
                  v-model="criarChave.secret"
                  dense
                  outlined
                />
              </div>
            </div>
            <div class="q-my-lg q-px-md">
              <q-btn
                label="Criar"
                style="
                  background-color: #21324a;
                  border-radius: 8px;
                  color: white;
                "
                no-caps
                :disable="
                  !criarChave.tenant || !criarChave.key || !criarChave.secret
                "
                icon="done"
                @click="criar()"
              />
            </div>
          </div>
        </div>
        <div v-else style="width: 100%; height: 89%">
          <div class="column col-12 justify-between no-wrap container-modal">
            <div class="q-px-md text-weight-bold">
              <div>
                <div class="texto-titulo-input">Key</div>
                <q-input
                  class="input-modal input-new-design"
                  v-model="editarChaveDados.key"
                  autocomplete="off"
                  dense
                  outlined
                  maxlength="100"
                />
              </div>
              <div class="q-mt-xs">
                <div class="texto-titulo-input">Secret</div>
                <q-input
                  autocomplete="off"
                  class="input-modal input-new-design"
                  v-model="editarChaveDados.secret"
                  dense
                  outlined
                />
              </div>
            </div>
            <div class="q-my-lg q-px-md">
              <q-btn
                label="Editar"
                color="positive"
                no-caps
                icon="done"
                @click="editar()"
              />
            </div>
          </div>
        </div>
      </q-card>
    </Transition>
    <div class="q-mt-xl">
      <div class="q-mt-lg">
        <q-table
          id="customers"
          table-header-class="bg-accent text-weight-bold"
          :rows="listaTerceiros"
          :columns="columns"
          class="tabela-tamanho-fixo"
          dense
          :rows-per-page-options="[0]"
          :loading="loading"
          color="primary"
          flat
        >
          <template v-slot:no-data="props">
            <div
              v-if="props"
              style="background-color: transparent"
              class="full-width row flex-center q-gutter-sm q-mt-sm"
            >
              <q-img
                src="./../../../assets/tabelSemDados.svg"
                style="height: 170px; width: 150px"
              />
            </div>
          </template>
          <template v-slot:top-left>
            <span
              style="
                font-size: 16px;
                display: block;
                margin-left: -15px;
                color: #21324a;
              "
              >Chaves Existentes</span
            >
          </template>
          <template v-slot:body="props">
            <q-tr :props="props">
              <q-td class="text-left" key="tenant" :props="props">
                {{ props.row.tenant }}
              </q-td>
              <q-td class="text-left" key="key" :props="props">
                {{ props.row.key }}
              </q-td>
              <q-td class="text-left" key="secret" :props="props">
                {{ props.row.secret }}
              </q-td>
              <q-td class="text-left" key="status" :props="props">
                <div
                  v-if="props.row.status == 'ativo'"
                  class="row align items-center"
                  style="
                    width: fit-content;
                    background: #e8ffec;
                    padding: 2px 5px;
                  "
                >
                  <span class="elipse q-mr-sm bg-positive" />
                  <div
                    style="width: fit-content"
                    class="text-bold text-brand-5"
                  >
                    {{ "Ativo" }}
                  </div>
                </div>
                <div
                  v-else
                  class="row align items-center"
                  style="
                    width: fit-content;
                    background: #ffe9e9;
                    padding: 2px 5px;
                  "
                >
                  <span class="elipse q-mr-sm bg-red" />
                  <div
                    style="width: fit-content; color: #850202"
                    class="text-bold"
                  >
                    {{ "Inativo" }}
                  </div>
                </div>
              </q-td>
              <q-td class="text-left" key="ativacao" :props="props">
                <q-btn
                  icon="sym_o_close"
                  v-if="props.row.status == 'ativo'"
                  flat
                  color="negative"
                  dense
                  no-caps
                  @click="
                    (chaveId = props.row.uuid),
                      (estaAtivo = true),
                      (excluirChave = false),
                      (confirmacao = !confirmacao)
                  "
                />
                <q-btn
                  v-else
                  icon="sym_o_done"
                  flat
                  color="positive"
                  dense
                  no-caps
                  @click="
                    (chaveId = props.row.uuid),
                      (estaAtivo = false),
                      (excluirChave = false),
                      (confirmacao = !confirmacao)
                  "
                />
              </q-td>
              <q-td class="center" key="editar" :props="props">
                <q-btn
                  icon="sym_o_edit"
                  flat
                  color="primary"
                  dense
                  no-caps
                  @click="
                    (rightDrawerOpen = true),
                      (editarChave = true),
                      (editarChaveDados = { ...props.row }),
                      (nomeTerceiroEditar = props.row.secret)
                  "
                />
              </q-td>
              <q-td class="center" key="remover" :props="props">
                <q-btn
                  icon="sym_o_delete"
                  flat
                  color="red"
                  dense
                  no-caps
                  @click="
                    (chaveId = props.row.uuid),
                      (excluirChave = true),
                      (confirmacao = !confirmacao)
                  "
                />
              </q-td>
            </q-tr>
          </template>
        </q-table>
      </div>
    </div>
    <div
      v-if="rightDrawerOpen"
      @click="rightDrawerOpen = false"
      class="mascara"
    ></div>
    <dialog-confirm-design
      mensagem="Tem certeza que deseja excluir a Empresa / Terceiro?"
      :exibir="confirmacao"
      @resultado="removerChaveFacial"
    />
  </q-page>
</template>

<script>
import { ref, onMounted, watch } from "vue";
import { useStore } from "vuex";
import { useQuasar } from "quasar";
import { validarDataEmissao } from "../../../helpers/dateValidation";

//import ListaUnidadesSelect from "../../organizacional/unidade/component/ListaUnidadesSelect.vue";
import DialogConfirmDesign from "../../../components/DialogConfirmDesign.vue";
import { watchDebounced } from "@vueuse/core";
export default {
  name: "Cadastrarterceiro",
  components: { DialogConfirmDesign },
  setup() {
    const emitir = ref({
      unidade: "",
      local: "",
      descricao: "",
      dataInicio: new Date().toLocaleString("pt-br"),
      dataTermino: new Date().toLocaleString("pt-br"),
    });

    const terceiro = ref({
      terceiroId: "",
      parceiro: "",
      nome: "",
      matricula: "",
      area: "",
      email: "",
      celular: "",
    });
    const confirmacao = ref(false);
    const area = ref({
      areaId: "",
      unidadeId: "",
      nome: "",
    });

    const criarChave = ref({
      tenant: "",
      key: "",
      secret: "",
    });

    const editarChaveDados = ref({
      uuid: "",
      key: "",
      secret: "",
    });

    const filtros = ref({
      uuid: "",
      tenant: "",
      key: "",
      secret: "",
      status: "",
      dataInicial: "",
      dataFinal: "",
      excluido: "",
    });
    const chaveId = ref("");
    const ativacao = ref(null);
    const excluirChave = ref(true);
    const listaTerceiros = ref([]);
    const listaArea = ref([]);
    const listaParceiros = ref([]);
    const estaAtivo = ref(null);
    const loading = ref(false);
    const $q = useQuasar();
    const listaClientes = ref([]);
    const myForm = ref(null);
    const dadoEditar = ref({});
    const store = useStore();
    let editarChave = ref(false);
    let rightDrawerOpen = ref(false);
    const nomeTerceiroEditar = ref("");
    const columns = [
      {
        name: "tenant",
        label: "Tenant",
        field: "tenant",
        align: "left",
        sortable: false,
      },
      {
        name: "key",
        label: "Key",
        field: "key",
        align: "left",
        sortable: false,
      },
      {
        name: "secret",
        label: "Secret",
        field: "secret",
        align: "left",
        sortable: false,
      },
      {
        name: "status",
        label: "Status",
        field: "status",
        align: "left",
        sortable: false,
      },
      {
        name: "ativacao",
        label: "Ativar/Inativar",
        field: "ativacao",
        align: "left",
        sortable: false,
      },
      {
        name: "editar",
        label: "Editar",
        align: "left",
      },
      {
        name: "remover",
        label: "Remover",
        align: "left",
      },
    ];

    let listarChaves = async () => {
      loading.value = true;
      try {
        let resposta = await store.dispatch("office/listarChavesFacial", {
          uuid: filtros.value?.uuid == "" ? undefined : filtros.value?.uuid,
          tenant:
            filtros.value?.tenant == "" ? undefined : filtros.value?.tenant,
          key: filtros.value?.key == "" ? undefined : filtros.value?.key,
          secret:
            filtros.value?.secret == "" ? undefined : filtros.value?.secret,
          status:
            filtros.value?.status == "" ? undefined : filtros.value?.status,
          dataInicia:
            filtros.value?.dataInicial == ""
              ? undefined
              : filtros.value?.dataInicial,
          dataFinal:
            filtros.value?.dataFinal == ""
              ? undefined
              : filtros.value?.dataFinal,
          excluido:
            filtros.value?.excluido == "" ? undefined : filtros.value?.excluido,
        });

        listaTerceiros.value = resposta.data.result.data;
        loading.value = false;
      } catch (error) {
        console.error(error);
      }
    };

    const listarArea = async () => {
      await emitir.value.unidade.id;
      try {
        let resposta = await store.dispatch("area/listar", {
          unidadeId: emitir.value.unidade.id,
        });
        listaArea.value = resposta.listaArea;
        // terceiro.value.areaId = listaArea.value;
      } catch (error) {
        console.error(error);
      }
    };

    watch(
      () => store.state.org.unidadeData,
      () => {
        emitir.value.unidade = store.state.org.unidadeData;
        reset();
        listarArea();
      }
    );

    const getUnidade = () => {
      if (!store.state.org.unidadeData) {
        return;
      }
      emitir.value.unidade = store.state.org.unidadeData;
    };

    onMounted(() => {
      listarChaves();
      listarClientes();
      getUnidade();
    });

    watchDebounced(
      filtros.value,
      () => {
        listarChaves();
      },
      { debounce: 800 },
      { deep: true }
    );

    const criar = async () => {
      try {
        await store.dispatch("office/criarChaveFacial", {
          tenant: criarChave.value.tenant,
          key: criarChave.value.key,
          secret: criarChave.value.secret,
        });

        $q.notify({
          message: "Chave cadastrado com sucesso.",
          color: "positive",
          actions: [
            {
              label: "Fechar",
              color: "white",
              handler: () => {
                /* ... */
              },
            },
          ],
        });
        reset();
        listarChaves();
      } catch (e) {
        $q.notify({
          message:
            "As credenciais informadas estão inválidas. Verifique se a mesma foi previamente cadastrada na TechTrue.",
          color: "negative",
          actions: [
            {
              label: "Fechar",
              color: "white",
              handler: () => {
                /* ... */
              },
            },
          ],
        });
      }
    };

    const editar = async () => {
      try {
        await store.dispatch("office/editarChaveFacial", {
          key: editarChaveDados.value.key,
          secret: editarChaveDados.value.secret,
          uuid: editarChaveDados.value.uuid,
        });

        $q.notify({
          message: "Chave editada com sucesso.",
          color: "positive",
          actions: [
            {
              label: "Fechar",
              color: "white",
              handler: () => {
                /* ... */
              },
            },
          ],
        });
        reset();
        listarChaves();
      } catch (e) {
        $q.notify({
          message:
            "Erro a o editar chave, verifique se a mesma foi previamente cadastrada na TechTrue",
          color: "negative",
          actions: [
            {
              label: "Fechar",
              color: "white",
              handler: () => {
                /* ... */
              },
            },
          ],
        });
      }
    };

    const reset = async () => {
      terceiro.value = {};
      filtros.value = {
        uuid: "",
        tenant: "",
        key: "",
        secret: "",
        status: "",
        dataInicial: "",
        dataFinal: "",
        excluido: "",
      };
      dadoEditar.value = {};
      rightDrawerOpen.value = false;
    };

    const removerChaveFacial = async (resultado) => {
      confirmacao.value = false;
      if (resultado) {
        try {
          if (excluirChave.value) {
            await store.dispatch("office/removerChaveFacial", {
              uuid: chaveId.value,
            });
          } else {
            if (estaAtivo.value) {
              await store.dispatch("office/desativarChaveFacial", {
                uuid: chaveId.value,
              });
            } else {
              await store.dispatch("office/ativarChaveFacial", {
                uuid: chaveId.value,
              });
            }
          }

          $q.notify({
            message: "Realizado com sucesso",
            color: "positive",
            actions: [
              {
                label: "Fechar",
                color: "white",
                handler: () => {
                  /* ... */
                },
              },
            ],
          });
          listarChaves();
        } catch (error) {
          console.log(error);
          $q.notify({
            message: "Erro ao fazer requsicao",
            color: "negative",
            actions: [
              {
                label: "Fechar",
                color: "white",
                handler: () => {
                  /* ... */
                },
              },
            ],
          });
        }
      }
    };

    let listarClientes = async () => {
      try {
        let resposta = await store.dispatch("office/listarCliente");

        listaClientes.value = resposta.listaClientes;

        loading.value = false;
      } catch (error) {
        console.error(error);
      }
    };

    watch(
      () => rightDrawerOpen.value,
      () => {
        if (!rightDrawerOpen.value) {
          editarChave.value = false;
          dadoEditar.value = {};
        }
      }
    );

    return {
      terceiro,
      loading,
      criar,
      myForm,
      listaTerceiros,
      listarArea,
      listaArea,
      listarClientes,
      listaParceiros,
      listarChaves,
      columns,
      area,
      filtros,
      listaClientes,
      emitir,
      getUnidade,
      removerChaveFacial,
      editarChave,
      editarChaveDados,
      dadoEditar,
      rightDrawerOpen,
      nomeTerceiroEditar,
      editar,
      confirmacao,
      chaveId,
      excluirChave,
      myLocale: {
        /* starting with Sunday */
        days: "Domingo_Segunda_Terça_Quarta_Quinta_Sexta_Sábado".split("_"),
        daysShort: "Dom_Seg_Ter_Quar_Quin_Sex_Sáb".split("_"),
        months:
          "Janeiro_Fevereiro_Março_Abril_Maio_Junho_Julho_Agosto_Setembro_Outubro_Novembro_Dezembro".split(
            "_"
          ),
        monthsShort: "Jan_Fev_Mar_Abr_Mai_Jun_Jul_Ago_Set_Out_Nov_Dez".split(
          "_"
        ),
        firstDayOfWeek: 1,
      },
      statusOptions: [
        {
          label: "Ativo",
          value: "ativo",
        },
        {
          label: "Inativo",
          value: "inativo",
        },
      ],

      excluidoOptions: [
        {
          label: "Sim",
          value: true,
        },
        {
          label: "Não",
          value: false,
        },
      ],
      perpageOptions: [10, 25, 50, 100, 200, 500],
      ativacao,
      estaAtivo,
      criarChave,
      validarDataEmissao,
    };
  },
};
</script>

<style scoped>
a {
  text-decoration: none;
}
.elipse {
  width: 12px;
  height: 12px;
  border-radius: 50%;
}
.titulo-tabela {
  font-size: 18px;
}
.animacao {
  transition: all 0.5s;
  cursor: pointer;
}
.animacao:hover {
  -webkit-transform: scale(1.1);
  -ms-transform: scale(1.1);
  transform: scale(1.1);
}
.drawer-modal {
  border: 2px solid black;
  position: absolute;
  right: 0;
  width: 450px;
  position: fixed;
  top: 106px;
  height: calc(100% - 10px);
  max-height: 650px;
  border-radius: 10px 1px 1px 10px;
  margin: 2px;
  z-index: 3;
  overflow: hidden;
}
.slide-fade-enter-active {
  transition: all 0.5s ease-out;
}
.slide-fade-leave-active {
  transition: all 0.5s cubic-bezier(1, 0.5, 0.8, 1);
}

.slide-fade-enter-from,
.slide-fade-leave-to {
  transform: translateX(400px);
}
.mascara {
  background-color: black;
  height: 100% !important;
  width: 100%;
  position: fixed;
  top: 0;
  left: 0;
  z-index: 2;
  opacity: 0.4;
}
.container-modal {
  height: 100%;
}
.texto-titulo-modal {
  font-size: 16px;
  color: #21324a;
}
@media (max-width: 1400px) {
  .drawer-modal {
    height: 80%;
    overflow: hidden;
  }
}
@media (max-width: 1200px) {
  .drawer-modal {
    max-height: 80%;
    overflow: hidden;
  }
}
@media (max-width: 1000px) {
  .drawer-modal {
    max-height: 80%;
    top: 118px;
    overflow: hidden;
  }
}
@media (max-width: 900px) {
  .drawer-modal {
    max-height: 80%;
    top: 118px;
    overflow: hidden;
  }
}
@media (max-width: 700px) {
  .drawer-modal {
    max-height: 80%;
    overflow: hidden;
    top: 107px;
  }
}
</style>

<style>
.input-new-design .q-field--outlined .q-field__control {
  border-radius: 8px !important;
}

.input-new-design .q-field__control:before {
  border-radius: 8px !important;
}

.input-label {
  color: #21324a;
}
</style>
